// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2RkEu"};